var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSection',{staticClass:"news-preview",attrs:{"data":{ img: '' }}},[(_vm.title !== '')?_c('AppHeadline',{staticClass:"news-preview__title",attrs:{"data":{
      content: _vm.title,
      type: 2,
    }}}):_vm._e(),_c('div',{staticClass:"news-preview__container"},_vm._l((_vm.items),function(item,i){return _c('router-link',{key:i,staticClass:"news-preview__card",attrs:{"to":("/insights" + (item.path))}},[_c('div',{staticClass:"news-preview__image",style:({
          backgroundImage: ("url(" + (item.acf.image.url) + ")")
        })}),_c('AppSubheading',{staticClass:"news-preview__eyelet",attrs:{"data":{
          content: item.acf.category.name,
        }}}),_c('AppParagraph',{attrs:{"data":{
          content: item.title,
        }}})],1)}),1),_c('router-link',{staticClass:"news-preview__button",attrs:{"to":"/insights"}},[(_vm.haveButton)?_c('AppButton',{attrs:{"data":{ content: 'SEE ALL' }}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }